/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  Error,
  GetConfigurationByNameResponse,
  GetFeatureFlagsResponse,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get feature flags status
 */
export const getFeatureFlags = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetFeatureFlagsResponse>(
    { url: `/api/v1/config/featureFlags`, method: "GET", signal },
    options,
  )
}

export const getGetFeatureFlagsQueryKey = () => {
  return ["api", "v1", "config", "featureFlags"] as const
}

export const useGetFeatureFlagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlags>>, TError, TData>
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetFeatureFlagsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureFlags>>> = ({
    signal,
  }) => getFeatureFlags(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getFeatureFlags>>,
    TError,
    TData
  >
}

export type GetFeatureFlagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeatureFlags>>
>
export type GetFeatureFlagsQueryError = ErrorType<Error>

/**
 * @summary Get feature flags status
 */

export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * @summary Get a configuration value by name
 */
export const getConfigurationByName = (
  configurationName: MaybeRefOrGetter<string>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  configurationName = toValue(configurationName)

  return customInstance<GetConfigurationByNameResponse>(
    {
      url: `/api/v1/configurations/${configurationName}`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetConfigurationByNameQueryKey = (
  configurationName: MaybeRefOrGetter<string>,
) => {
  return ["api", "v1", "configurations", configurationName] as const
}

export const useGetConfigurationByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getConfigurationByName>>,
  TError = ErrorType<Error>,
>(
  configurationName: MaybeRefOrGetter<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConfigurationByName>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetConfigurationByNameQueryKey(configurationName)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConfigurationByName>>
  > = ({ signal }) =>
    getConfigurationByName(configurationName, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () =>
          toValue(configurationName) !== null &&
          toValue(configurationName) !== undefined,
      ),
      ...queryOptions,
    },
    { configurationName },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getConfigurationByName>>,
    TError,
    TData
  >
}

export type GetConfigurationByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConfigurationByName>>
>
export type GetConfigurationByNameQueryError = ErrorType<Error>

/**
 * @summary Get a configuration value by name
 */

export function useGetConfigurationByName<
  TData = Awaited<ReturnType<typeof getConfigurationByName>>,
  TError = ErrorType<Error>,
>(
  configurationName: MaybeRefOrGetter<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConfigurationByName>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetConfigurationByNameQueryOptions(
    configurationName,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
